module.exports = __webpack_public_path__ + "static/media/errorboundary.0b5bd3c1.png";